import { API_ENDPOINTS } from "../constants/apiConfig";
import { makeRequest } from "../middleware/axiosMiddleware"

export const annexureService = {
    getAnnexureList,
    addAnnxurePart,
    editAnnexurePart,
    updateAnnexurePart,
    deleteAnnexurePart,
    getAllAnnexureList,
    importAnnexureParts
};

async function getAnnexureList(skip: any, page: any, partNumber: any) {
    let apiPath;
    if (partNumber) {
        apiPath = API_ENDPOINTS.ANNEXURE + `/enquiries/products/getAnnexurePart?skip=${skip}&limit=${page}&partNumber=${partNumber}`;
    } else {
        apiPath = API_ENDPOINTS.ANNEXURE + `/enquiries/products/getAnnexurePart?skip=${skip}&limit=${page}`;
    }
    // const apiPath = API_ENDPOINTS.ANNEXURE + `/enquiries/products/getAnnexurePart?skip=0&limit=10&partNumber=j010`;
    const options = {
        path: `${apiPath}`,
        method: "GET",
        bodyObj: {
        },
        customHeaders: {
            "Paging-Info": `start-index=${page ? (parseInt(page) * 10) : 0}|no-of-records=10`
        },
        FormData: true
    }
    return await makeRequest(options)
}

async function getAllAnnexureList() {
    const apiPath = API_ENDPOINTS.ANNEXURE + `/enquiries/products/getAnnexurePart`;
    const options = {
        path: `${apiPath}`,
        method: "GET",
        bodyObj: {
        },
        customHeaders: {
            // "Paging-Info": `start-index=${page ? (parseInt(page) * 10) : 0}|no-of-records=10`
        },
        FormData: true
    }
    return await makeRequest(options)
}


async function editAnnexurePart(partNumber: any) {
    const apiPath = API_ENDPOINTS.ANNEXURE + `/enquiries/products/getAnnexurePart?partNumber=${partNumber}`;
    const options = {
        path: `${apiPath}`,
        method: "GET",
        bodyObj: {},
        customHeaders: {},
        FormData: true
    }
    return await makeRequest(options)
}

async function updateAnnexurePart(data: any) {
    const apiPath = API_ENDPOINTS.ANNEXURE + `/enquiries/products/updateAnnexurePart`;
    const options = {
        path: `${apiPath}`,
        method: "PUT",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    }
    return await makeRequest(options)
}

async function deleteAnnexurePart(data: any) {
    const apiPath = API_ENDPOINTS.ANNEXURE + `/enquiries/products/deleteAnnexurePart`;
   const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    };
    return await makeRequest(options)
}

async function addAnnxurePart(data: any) {
    const apiPath = API_ENDPOINTS.ANNEXURE + `/enquiries/products/addAnnexurePart`;
    const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    };
    return await makeRequest(options)
}

async function importAnnexureParts(data: any, headers: any) {
    const apiPath = API_ENDPOINTS.ANNEXURE + `/enquiries/documents/importAnnexureParts`;
    const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: headers,
        formdata: true
    };
    return await makeRequest(options)
}

